import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94856b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map_detail" }

import WhiteBox from '@/components/atoms/WhiteBox'
import SimpleButton from '@/components/atoms/SimpleButton'



export default /*#__PURE__*/_defineComponent({
  __name: 'MapDetailBackButton',
  emits: ["showDetailPage"],
  setup(__props, { emit }: { emit: ({
  (e: 'showDetailPage', value: boolean): void
}), expose: any, slots: any, attrs: any }) {



const changeDetailListShow = () => {
  emit('showDetailPage', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(WhiteBox), { padding: 0 }, {
      default: _withCtx(() => [
        _createVNode(_unref(SimpleButton), {
          onClick: changeDetailListShow,
          color: "color-dark3",
          size: "size-s",
          "icon-size": "40",
          "use-border": false,
          icon: "keyboard_arrow_left"
        })
      ]),
      _: 1
    })
  ]))
}
}

})